"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../locale/index");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Registry = /*#__PURE__*/function () {
  function Registry() {
    _classCallCheck(this, Registry);
    this.objects = {};
  }
  return _createClass(Registry, [{
    key: "add",
    value: function add(key, value) {
      if (_typeof(key) == 'object' && typeof value == 'undefined') {
        for (var index in key) {
          this._add(index, key[index]);
        }
      } else if (typeof key == 'string' && value) {
        this._add(key, value);
      } else {
        throw Error('Cannot add object to Registry, key or value is missing.');
      }
    }
  }, {
    key: "_add",
    value: function _add(key, value) {
      if (typeof this.objects[key] != 'undefined') {
        throw Error('Registry object with this key is already set.');
      }
      this.objects[key] = value;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      if (typeof this.objects[key] != 'undefined') {
        return true;
      }
      return false;
    }
  }, {
    key: "remove",
    value: function remove(key, value) {
      if (typeof this.objects[key] == 'undefined') {
        throw Error('Registry object with this key is not set.');
      }
      delete this.objects[key];
    }
  }, {
    key: "get",
    value: function get(key) {
      if (typeof this.objects[key] == 'undefined') {
        throw Error('Registry object with this key is not set.');
      }
      return this.objects[key];
    }
  }]);
}();
var _instance;

/**
 * @return {Registry}
 */
function getInstance() {
  if (typeof document !== 'undefined') {
    if (!_instance) {
      _instance = new Registry();
      if (document.location) {
        var localeCode = document.location.pathname.includes('/en/') ? 'en' : 'fr';
        var locale = (0, _index.loadLocale)(localeCode);
        _instance.add({
          locale: locale
        });
      }
    }
    return _instance;
  }
}
var _default = exports["default"] = getInstance();